import NavBreadcrumb from './nav-breadcrumb'

export default NavBreadcrumb
